/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

// Mui
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ClearIcon from "@mui/icons-material/Clear";
import QrCodeIcon from "@mui/icons-material/QrCode";
import SearchIcon from "@mui/icons-material/Search";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SaveIcon from "@mui/icons-material/Save";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import constant from "@/config/constant";
import moment from "moment";
// Fetch
import { getGiveawayManage } from "@/fetch/fetchGiveaway";
import {
  createLanding,
  getAllLandingByProductId,
  getAvailableShopyDateRange,
  getLanding,
  updateLanding,
} from "@/fetch/fetchLanding";
import { getProducts } from "@/fetch/fetchStatistics";
import QRCode from "react-qr-code";

// Config
import { uuid } from "@/config/normalConfig";

// Other
import { enumerateDaysBetweenDates } from "@/lib/enumerateDaysBetweenDates";
import { Buffer } from "buffer";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDropzone } from "react-dropzone";

import connectConfig from "@/config/connectConfig";
import _ from "lodash";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const ManningsLandingSettingDetailPage = (props) => {
  const [updated, setUpdated] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [productOptions, setProductOptions] = React.useState([]);
  const [shopOptions, setShopOptions] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [giveawayOptions, setGiveawayOptions] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const [deleteFile, setDeleteFile] = React.useState([]);
  const [lock, setLock] = React.useState(false);
  const [notAvailableDate, setNotAvailableDate] = React.useState([]);
  const { open, setOpen } = props;
  const [landingUrl, setLandingUrl] = React.useState("");
  const { id } = useParams();
  const canvasRef = React.useRef(null);
  // Navigate
  const navigate = useNavigate();
  const today = moment();
  // States
  const [formData, setFormData] = React.useState({
    name: "",
    start_date: null,
    end_date: null,
    is_active: true,
    product_id: null,
    giveaway_ids: [],
    duplicate_registion: false,
    is_immediately: false,
    register_method: "signature",
    promotion_shop: [],
    images: [],
    term_conditions: "",
  });
  const editable =
    moment().isSameOrBefore(formData.end_date) || !formData.end_date;
  const handleSetFormData = (field, value) => {
    setFormData((prev) => {
      return {
        ...prev,
        [field]: value,
      };
    });
    setUpdated(true);
  };
  // DropZone
  const { getRootProps, getInputProps } = useDropzone({
    disabled: lock || !editable,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "image/gif": [".gif"],
      "image/webp": [".webp"],
    },
    onDrop: async (acceptedFiles) => {
      const addedImages = await handleImages(acceptedFiles);
      handleSetFormData("images", _.concat(formData.images, [...addedImages]));
    },
  });

  // Handle Delete Cliked
  const handleClickDelete = (item, action) => {
    let tempArr = [...deleteFile];
    if (action === "markAsDelete") {
      const images = [...formData.images];
      const deleteIndex = images.findIndex((image) => image.id === item.id);
      images[deleteIndex].flag = "delete";
      handleSetFormData("images", images);
      tempArr.push({
        id: item.id,
        key: item.images_name,
      });

      setDeleteFile(tempArr);
    }
    if (action === "cancel") {
      // Find the files object with the matching ID
      const objectToDelete = tempArr.find((obj) => obj.id === item.id);

      if (objectToDelete) {
        tempArr.splice(tempArr.indexOf(objectToDelete), 1);
        setDeleteFile(tempArr);
      }
    }
  };
  // handleCancelFile
  const handleCancelFile = (item) => {
    let filesPreviewArr = [...formData.images];
    let filesArr = files;

    // Find the files preview object with the matching ID
    const objectToDelete = filesPreviewArr.find(
      (obj) => obj.title === item.title
    );
    // Find the files object with the matching ID
    const objectToDelete2 = filesArr.find((obj) => obj.name === item.title);

    if (objectToDelete) {
      filesPreviewArr.splice(filesPreviewArr.indexOf(objectToDelete), 1);
      handleSetFormData("images", filesPreviewArr);
    }
    if (objectToDelete2) {
      filesArr.splice(filesArr.indexOf(objectToDelete2), 1);
      setFiles(filesArr);
    }
  };
  const handleImages = async (files) => {
    const imagesData = [];
    for (const file of files) {
      if (file.type === "image/gif") {
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
          reader.onloadend = async () => {
            const result = reader.result;
            const base64Data = result.replace(/^data:image\/gif;base64,/, "");
            const buffer = Buffer.from(base64Data, "base64");
            imagesData.push({
              title: file.name,
              img: URL.createObjectURL(file),
              flag: "new",
              key: `${uuid()}.gif`,
              buffer,
              type: "gif",
            });
            resolve(true);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      } else if (file.type === "image/webp") {
        const reader = new FileReader();
        await new Promise((resolve, reject) => {
          reader.onloadend = async () => {
            const result = reader.result;
            const base64Data = result.replace(/^data:image\/webp;base64,/, "");
            const buffer = Buffer.from(base64Data, "base64");

            imagesData.push({
              title: file.name,
              img: URL.createObjectURL(file),
              flag: "new",
              key: `${uuid()}.gif`,
              buffer,
              type: "webp",
            });
            resolve(true);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      } else {
        const image = new Image();
        image.src = URL.createObjectURL(file);
        await new Promise((resolve, reject) => {
          image.onload = resolve;
          image.onerror = reject;
        });
        canvasRef.current.width = image.width;
        canvasRef.current.height = image.height;
        const context = canvasRef.current.getContext("2d");
        context.drawImage(image, 0, 0);
        const dataURL = canvasRef.current.toDataURL("image/webp", 0.75);
        const base64Data = dataURL.replace(/^data:image\/webp;base64,/, "");
        const buffer = Buffer.from(base64Data, "base64");
        imagesData.push({
          title: file.name,
          img: URL.createObjectURL(file),
          flag: "new",
          key: `${uuid()}.webp`,
          buffer,
          type: "webp",
        });
      }
    }
    return imagesData;
  };

  // Submit
  const onSaveChange = async () => {
    setLock(true);
    try {
      if (
        !formData.name ||
        !formData.term_conditions ||
        !formData.product_id ||
        !formData.term_conditions ||
        formData.giveaway_ids.length <= 0 ||
        formData.images.length <= 0 ||
        (!formData.is_immediately && formData.promotion_shop.length <= 0)
      ) {
        setSnackSeverity("error");
        setSnackMessage("請輸入全部資料");
      } else if (
        !formData.start_date ||
        notAvailableDate.includes(formData.start_date) ||
        !formData.end_date ||
        notAvailableDate.includes(formData.end_date)
      ) {
        setSnackSeverity("error");
        setSnackMessage("日期不正確/重覆");
      } else {
        if (formData.id) {
          await updateLanding(formData);
          setSnackSeverity("success");
          setSnackMessage(`更新成功`);
          setSnackOpen(true);
          fetchAll();
        } else {
          const { data } = await createLanding(formData);
          navigate(`/manningsLanding/edit/${data}`);
          setSnackSeverity("success");
          setSnackMessage(`新增成功`);
          setSnackOpen(true);
        }
      }
    } catch (error) {
      setSnackSeverity("error");
      setSnackMessage(`${formData.id ? "更新" : "新增"}失敗`);
    } finally {
      setUpdated(false);
      setLock(false);
      setSnackOpen(true);
    }
  };
  const fetchShop = async (start_date, end_date) => {
    return new Promise(async (resolve, reject) => {
      const options = {};
      const start_date_moment = moment(start_date);
      const end_date_moment = moment(end_date);
      if (start_date_moment.isValid() && end_date_moment.isValid()) {
        const { data: rosters } = await getAvailableShopyDateRange(
          start_date_moment.format("YYYY-MM-DD"),
          end_date_moment.format("YYYY-MM-DD")
        );
        _.forEach(rosters, (roster) => {
          options[roster.location_id] = {
            id: roster.location_id,
            districts_name: roster.districts_name,
            work_name: roster.work_name,
            work_shortcode: roster.work_shortcode,
          };
        });
      }
      resolve(options);
    });
  };
  const fetchAllLandings = async (product_id) => {
    return new Promise(async (resolve, reject) => {
      let date = [];
      const { data: landings } = await getAllLandingByProductId(product_id);
      _.forEach(landings, (landing) => {
        if (parseInt(landing.id) !== parseInt(id)) {
          const dateArr = enumerateDaysBetweenDates(
            landing.start_date,
            landing.end_date
          );

          date = _.concat(date, dateArr);
        }
      });
      setNotAvailableDate(_.uniq(date));
      resolve(date);
    });
  };
  const fetchAll = async () => {
    const { data: products } = await getProducts();
    setProductOptions(
      _.chain(products).filter("is_active").sortBy("brand_name").value()
    );
    const { data: giveaways } = await getGiveawayManage();
    setGiveawayOptions(
      _.chain(giveaways).filter("is_active").sortBy("item_brand").value()
    );
    if (id) {
      const { data } = await getLanding(id);
      const domainName = constant.brand[data.brand_id] ?? "test-landing";
      setLandingUrl(
        `https://${domainName}.${connectConfig.manningsLandingsSuffixUrl}`
      );
      await fetchAllLandings(data.product_id);
      const options = await fetchShop(data.start_date, data.end_date);
      setShopOptions(_.sortBy(options, "districts_name"));

      setFormData({
        ...data,
        start_date: moment(data.start_date).format("YYYY-MM-DD"),
        end_date: moment(data.end_date).format("YYYY-MM-DD"),
      });
    }

    setSlideTranOn(true);
  };
  const handleDateChange = async (start_date, end_date) => {
    const options = await fetchShop(start_date, end_date);
    setShopOptions(_.sortBy(options, "districts_name"));
  };
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });
  React.useEffect(() => {
    fetchAll();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    fetchAllLandings(formData.product_id);
  }, [formData.product_id]);
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(formData.images);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    handleSetFormData("images", items);
  };
  const handleShopChange = async (event) => {
    if (_.includes(event.target.value, "ALL")) {
      if (event.target.value.length - 1 === shopOptions.length) {
        handleSetFormData("promotion_shop", []);
      } else {
        handleSetFormData(
          "promotion_shop",
          _.map(shopOptions, (o) => o.id)
        );
      }
    } else {
      handleSetFormData("promotion_shop", event.target.value);
    }
  };
  function makeItems(data) {
    const groupByDistrict = _.groupBy(data, "districts_name");
    const items = [];
    _.forEach(groupByDistrict, (values, district) => {
      items.push(
        <ListSubheader style={{ zIndex: 0 }} key={district}>
          <IconButton
            onClick={(event) => {
              let concatValue = [];
              const isExisting = data.find(
                (d) =>
                  d.districts_name === district &&
                  formData.promotion_shop.includes(d.id)
              );
              if (isExisting) {
                const currentValues = data.filter((options) =>
                  formData.promotion_shop.includes(options.id)
                );
                concatValue = _.map(
                  _.filter(currentValues, (d) => d.districts_name !== district),
                  "id"
                );
              } else {
                const options = _.filter(
                  shopOptions,
                  (s) => s.districts_name === district
                );

                concatValue = _.concat(
                  formData.promotion_shop,
                  _.map(options, "id")
                );
              }

              handleSetFormData("promotion_shop", concatValue);
            }}
          >
            {district}
          </IconButton>
        </ListSubheader>
      );
      _.forEach(_.sortBy(values, "work_shortcode"), (value, index) => {
        items.push(
          <MenuItem key={value.id} value={value.id}>
            <Checkbox
              checked={
                formData.promotion_shop.find((d) => d === value.id) !==
                undefined
              }
            />
            {`${value.work_shortcode} - ${value.work_name} `}
          </MenuItem>
        );
      });
    });
    return items;
  }
  return (
    <Layout
      header="LandingSettingDetailPage"
      selectedIndex={13}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      snackSeverity={snackSeverity}
      setOpen={setOpen}
    >
      <Title
        title={`${id ? "修改萬寧優惠" : "新增萬寧優惠"}`}
        history={() => navigate(-1)}
        children={
          <div>
            <>
              {id && (
                <React.Fragment>
                  <IconButton
                    component="label"
                    onClick={() => {
                      if (updated) {
                        alert("請先儲存當前設定");
                        return false;
                      }
                      window.open(
                        `${landingUrl}/?landing_id=${formData.id}&preview=true`
                      );
                    }}
                  >
                    <OpenInNewIcon />
                  </IconButton>
                  <IconButton
                    component="label"
                    onClick={() => {
                      if (updated) {
                        alert("請先儲存當前設定");
                        return false;
                      }
                      const svg = document.getElementById("QRCode");
                      const svgData = new XMLSerializer().serializeToString(
                        svg
                      );
                      const canvas = document.createElement("canvas");
                      const ctx = canvas.getContext("2d");
                      const img = new Image();
                      img.onload = () => {
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);
                        const pngFile = canvas.toDataURL("image/png");
                        const downloadLink = document.createElement("a");
                        downloadLink.download = `${formData.name}_QRCODE`;
                        downloadLink.href = `${pngFile}`;
                        downloadLink.click();
                      };
                      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
                    }}
                  >
                    <QrCodeIcon />
                  </IconButton>
                </React.Fragment>
              )}

              <IconButton
                component="label"
                onClick={() => onSaveChange()}
                disabled={lock || !editable}
              >
                <SaveIcon />
              </IconButton>
            </>
          </div>
        }
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              md: 12,
              lg: 12,
            }}
          >
            <StyledPaper page={"yes"} alignItems={"left"}>
              <ThemeProvider theme={theme}>
                <Grid container spacing={2}>
                  <Grid
                    size={{
                      xs: 12,
                      md: 4,
                      lg: 4,
                    }}
                  >
                    <TextField
                      id="outlined-name"
                      name="name"
                      label="優惠名稱"
                      error={formData.name ? false : true}
                      value={formData.name}
                      helperText={!formData.name ? "請填寫優惠名稱" : ""}
                      onChange={(event) =>
                        handleSetFormData(event.target.name, event.target.value)
                      }
                      sx={{ width: "100%" }}
                      disabled={lock || !editable}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 4,
                      lg: 4,
                    }}
                  >
                    <Autocomplete
                      disabled={lock || !editable || id}
                      onChange={(event, newValue) => {
                        handleSetFormData(
                          "product_id",
                          newValue ? newValue.id : null
                        );
                      }}
                      groupBy={(option) => option.brand_name}
                      getOptionKey={(option) => option.id}
                      getOptionLabel={(option) =>
                        `${option.m18_product_code} - ${option.product_name} (${option.region_name})`
                      }
                      value={productOptions.find(
                        (p) => p.id === formData.product_id
                      )}
                      id="product-combo-box"
                      options={productOptions}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={!formData.product_id}
                          helperText={!formData.product_id ? "請選擇產品" : ""}
                          label="產品"
                        />
                      )}
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li {...props} key={`product-${option.id}`}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.m18_product_code} - {option.product_name} (
                            {option.region_name})
                          </li>
                        );
                      }}
                    />
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 4,
                      lg: 4,
                    }}
                  >
                    <Autocomplete
                      disabled={lock || !editable}
                      onChange={(event, newValue) => {
                        handleSetFormData(
                          "giveaway_ids",
                          newValue ? [newValue.id] : []
                        );
                      }}
                      groupBy={(option) => option.item_brand.toUpperCase()}
                      getOptionKey={(option) => option.id}
                      getOptionLabel={(option) =>
                        `${option.m18_product_code} - ${option.item_name}`
                      }
                      value={giveawayOptions.find(
                        (p) => p.id === formData.giveaway_ids[0]
                      )}
                      id="product-combo-box"
                      options={giveawayOptions}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={formData.giveaway_ids <= 0}
                          helperText={
                            formData.giveaway_ids.length <= 0
                              ? "請選擇贈品"
                              : ""
                          }
                          label="贈品"
                        />
                      )}
                      renderOption={(props, option, { selected }) => {
                        return (
                          <li {...props} key={`giveaway-${option.id}`}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option.m18_product_code} - {option.item_name}
                          </li>
                        );
                      }}
                    />
                  </Grid>

                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 2,
                    }}
                  >
                    <FormControl
                      error={
                        !formData.start_date ||
                        notAvailableDate.includes(formData.start_date)
                      }
                    >
                      <DatePicker
                        name="start_date"
                        label="開始日期"
                        disabled={lock || !editable}
                        value={formData.start_date}
                        onChange={(value) => {
                          handleSetFormData(
                            "start_date",
                            moment(value).format("YYYY-MM-DD")
                          );
                          handleSetFormData("promotion_shop", []);
                          handleDateChange(value, formData.end_date);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%" }}
                            error={
                              !formData.start_date ||
                              notAvailableDate.includes(formData.start_date)
                            }
                          />
                        )}
                        renderDay={(day, _value, DayComponentProps) => {
                          const currentDay = day.format("YYYY-MM-DD");
                          return (
                            <PickersDay
                              style={{
                                color: notAvailableDate.includes(currentDay)
                                  ? "red"
                                  : "black",
                              }}
                              {...DayComponentProps}
                              disabled={notAvailableDate.includes(currentDay)}
                            />
                          );
                        }}
                      />
                      {!formData.start_date && (
                        <FormHelperText>請選擇開始日期</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 2,
                    }}
                  >
                    <FormControl
                      error={
                        !formData.end_date ||
                        notAvailableDate.includes(formData.end_date)
                      }
                    >
                      <DatePicker
                        name="end_date"
                        label="結束日期"
                        disabled={lock || !editable}
                        minDate={formData.start_date}
                        value={formData.end_date}
                        onChange={(value) => {
                          handleSetFormData(
                            "end_date",
                            moment(value).format("YYYY-MM-DD")
                          );
                          handleSetFormData("promotion_shop", []);
                          handleDateChange(formData.start_date, value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%" }}
                            error={
                              !formData.end_date ||
                              notAvailableDate.includes(formData.end_date)
                            }
                          />
                        )}
                        renderDay={(day, _value, DayComponentProps) => {
                          const currentDay = day.format("YYYY-MM-DD");
                          return (
                            <PickersDay
                              style={{
                                color: notAvailableDate.includes(currentDay)
                                  ? "red"
                                  : "black",
                              }}
                              {...DayComponentProps}
                              disabled={notAvailableDate.includes(currentDay)}
                            />
                          );
                        }}
                      />
                      {!formData.end_date && (
                        <FormHelperText>請選擇結束日期</FormHelperText>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 1,
                    }}
                  >
                    <TextField
                      id="outlined-select"
                      select
                      label="即場登記"
                      name="is_immediately"
                      value={formData.is_immediately}
                      onChange={(event) =>
                        handleSetFormData(event.target.name, event.target.value)
                      }
                      sx={{ width: "100%" }}
                      disabled={lock || !editable}
                    >
                      <MenuItem value={true}>是</MenuItem>
                      <MenuItem value={false}>否</MenuItem>
                    </TextField>
                  </Grid>
                  {!formData.is_immediately && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 3,
                        lg: 3,
                      }}
                    >
                      <FormControl
                        fullWidth
                        error={formData.promotion_shop.length <= 0}
                      >
                        <InputLabel id="shop-select-label">換領店鋪</InputLabel>
                        <Select
                          disabled={lock || !editable}
                          MenuProps={{ autoFocus: false }}
                          labelId="shop-select-label"
                          id="shop-select"
                          value={formData.promotion_shop}
                          label="店鋪"
                          multiple
                          fullWidth
                          onChange={handleShopChange}
                          renderValue={(selected) => {
                            return selected.length === shopOptions.length
                              ? "所有店鋪"
                              : `已選擇${selected.length}間`;
                          }}
                          onClose={() => setSearchText("")}
                          input={<OutlinedInput label="換領店鋪" />}
                        >
                          <ListSubheader
                            style={{
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                            }}
                          >
                            <TextField
                              sx={{ width: 600 }}
                              style={{
                                backgroundColor: "white",
                              }}
                              autoFocus
                              slotProps={{
                                input: {
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <SearchIcon />
                                    </InputAdornment>
                                  ),
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        edge="end"
                                        onClick={() => setSearchText("")}
                                      >
                                        <ClearIcon />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                },
                              }}
                              InputProps={{}}
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                  // Prevents autoselecting item while typing (default Select behaviour)
                                  e.stopPropagation();
                                }
                              }}
                            />
                          </ListSubheader>
                          <MenuItem
                            key={"ALL"}
                            value={"ALL"}
                            style={{
                              position: "sticky",
                              top: 56,
                              backgroundColor: "white",
                              zIndex: 1,
                            }}
                          >
                            <Checkbox
                              checked={
                                formData.promotion_shop.length ===
                                shopOptions.length
                              }
                            />
                            <ListItemText primary={"所有店鋪"} />
                          </MenuItem>
                          {makeItems(
                            _.filter(shopOptions, (s) => {
                              return (
                                s?.work_shortcode
                                  ?.toLowerCase()
                                  ?.indexOf(searchText.toLowerCase()) > -1 ||
                                s?.work_name
                                  ?.toLowerCase()
                                  ?.indexOf(searchText.toLowerCase()) > -1
                              );
                            })
                          )}
                        </Select>
                        {formData.promotion_shop.length <= 0 && (
                          <FormHelperText>請選擇店鋪</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 1,
                    }}
                  >
                    <TextField
                      id="outlined-select"
                      select
                      label="登記方式"
                      name="register_method"
                      value={formData.register_method}
                      onChange={(event) =>
                        handleSetFormData(event.target.name, event.target.value)
                      }
                      sx={{ width: "100%" }}
                      disabled={lock || !editable}
                    >
                      <MenuItem value={"signature"}>簽名</MenuItem>
                      <MenuItem value={"photo"}>相片</MenuItem>
                      <MenuItem value={"none"}>N/A</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 2,
                    }}
                  >
                    <TextField
                      id="outlined-select"
                      select
                      label="是否接受重覆登記"
                      name="duplicate_registion"
                      value={formData.duplicate_registion}
                      onChange={(event) =>
                        handleSetFormData(event.target.name, event.target.value)
                      }
                      sx={{ width: "100%" }}
                      disabled={lock || !editable}
                    >
                      <MenuItem value={true}>可以</MenuItem>
                      <MenuItem value={false}>不可以</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    size={{
                      xs: 12,
                      md: 6,
                      lg: 1,
                    }}
                  >
                    <TextField
                      id="outlined-select"
                      select
                      label="選擇狀態"
                      name="is_active"
                      value={formData.is_active}
                      onChange={(event) =>
                        handleSetFormData(event.target.name, event.target.value)
                      }
                      sx={{ width: "100%" }}
                      disabled={lock || !editable}
                    >
                      <MenuItem value={false}>草稿</MenuItem>
                      <MenuItem value={true}>發佈</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid
                    size={{
                      xs: 12,
                      md: 12,
                      lg: 12,
                    }}
                  >
                    條款及細則
                    <CKEditor
                      disabled={lock || !editable}
                      config={{
                        toolbar: {
                          items: [
                            "undo",
                            "redo",
                            "|",
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "numberedList",
                            "bulletedList",
                          ],
                        },
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        handleSetFormData("term_conditions", data);
                      }}
                      data={formData.term_conditions}
                      editor={ClassicEditor}
                    />
                    <QRCode
                      id={"QRCode"}
                      size={256}
                      style={{ height: "0", width: "0" }}
                      value={`${landingUrl}/?id=${formData.product_id}`}
                      viewBox={`0 0 256 256`}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </StyledPaper>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 12,
              lg: 12,
            }}
          >
            <DragDropContext onDragEnd={onDragEnd}>
              <ThemeProvider theme={theme}>
                <StyledPaper page={"yes"}>
                  <Box
                    noValidate
                    sx={{
                      display: "flex",
                      width: "100%",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px dashed",
                      borderRadius: "20px",
                      borderColor: lock ? "#dbdbdb" : "black",
                      marginBottom: "20px",
                    }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <p>
                      {lock ? (
                        <>
                          上傳中 <CircularProgress size={10} />
                        </>
                      ) : files.length > 0 ? (
                        `已選擇${files.length}張圖片`
                      ) : (
                        "按此 / 拉進 選擇圖片"
                      )}
                    </p>
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                  </Box>
                  {formData.images.length > 0 && (
                    <Droppable droppableId="imagesList" direction="horizontal">
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          style={{
                            display: "flex",
                            overflowX: "scroll",
                            overflowY: "hidden",
                            width: "100%",
                          }}
                        >
                          {formData.images.map((item, i) => {
                            if (
                              !deleteFile.some((file) => file.id === item.id)
                            ) {
                              return (
                                <Draggable
                                  key={item.id ?? item.title}
                                  draggableId={
                                    item.id ? item.id.toString() : item.title
                                  }
                                  index={i}
                                >
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "end",
                                        }}
                                      >
                                        <>
                                          {item.id ? (
                                            <>
                                              <IconButton
                                                component="label"
                                                color="error"
                                                onClick={() =>
                                                  handleClickDelete(
                                                    item,
                                                    deleteFile.some(
                                                      (value) =>
                                                        value.id === item.id
                                                    )
                                                      ? "cancel"
                                                      : "markAsDelete"
                                                  )
                                                }
                                                disabled={lock}
                                              >
                                                <DeleteForeverIcon />
                                              </IconButton>
                                            </>
                                          ) : (
                                            <IconButton
                                              component="label"
                                              color="error"
                                              onClick={() =>
                                                handleCancelFile(item)
                                              }
                                              disabled={lock}
                                            >
                                              <CancelIcon />
                                            </IconButton>
                                          )}
                                        </>
                                      </div>
                                      <img
                                        src={
                                          item.id
                                            ? `${connectConfig.s3}/${item.image_path}`
                                            : item.img
                                        }
                                        alt={item.title}
                                        loading="lazy"
                                        style={{
                                          maxWidth: 250,
                                          minWidth: 250,
                                          borderRadius: 20,
                                          marginRight: 10,
                                          opacity: item.images_hidden ? 0.3 : 1,
                                        }}
                                      />
                                    </div>
                                  )}
                                </Draggable>
                              );
                            }
                            return <></>;
                          })}

                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  )}
                </StyledPaper>
              </ThemeProvider>
            </DragDropContext>
          </Grid>
        </Grid>
      </Fade>
    </Layout>
  );
};

export default ManningsLandingSettingDetailPage;
